(() => {
  const init = scope => {
    scope.querySelectorAll('[data-note-stage]').forEach(details => {
      if (details.dataset.noteReady) return;
      details.dataset.noteReady = 'true';
      const summary = details.querySelector('summary');
      const panel = details.querySelector('.note-stage-panel');
      let motion;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      summary.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
      summary.addEventListener('click', event => {
        if (reduced.matches || !panel.animate) return;
        event.preventDefault();
        if (motion) return;
        const opening = !details.open;
        if (opening) details.open = true;
        summary.setAttribute('aria-expanded', String(opening));
        details.classList.toggle('note-stage-closing', !opening);
        const height = panel.scrollHeight;
        motion = panel.animate([
          { height: opening ? '0px' : `${height}px`, opacity: opening ? 0 : 1 },
          { height: opening ? `${height}px` : '0px', opacity: opening ? 1 : 0 }
        ], { duration: opening ? 460 : 320, easing: 'cubic-bezier(.22,.61,.36,1)' });
        const finish = () => {
          if (!opening) details.open = false;
          details.classList.remove('note-stage-closing');
          motion = null;
        };
        motion.onfinish = finish;
        motion.oncancel = finish;
      });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
